import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "antd";
import { gql, useQuery } from "@apollo/client";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

const pageQuery = gql`
    query getPage($id: ID) {
        wbPage(id: $id) {
            data {
                attributes {
                    title
                    type {
                        ... on ComponentLayoutsOneColumn {
                            prefixTitle
                            title
                            suffixTitle
                            sections {
                                content
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default function OneColumn({ pageId }) {
    const location = useLocation();
    const [page, setPage] = useState(null);
    const { loading, error, data } = useQuery(pageQuery, {
        variables: {
            id: pageId,
        },
    });

    useEffect(() => {
        if (data?.wbPage?.data?.attributes?.type[0]) {
            ReactGA.send({ hitType: "pageview", page: location.pathname, title: data.wbPage.data.attributes.type[0].title });
            setPage(data.wbPage.data.attributes.type[0]);
        }
    }, [data]);

    useEffect(() => {
        document.body.classList.add("PageContactUs");
        return () => {
            document.body.classList.remove("PageContactUs");
        };
    }, []);

    if (loading || !page) return <p>Loading...</p>;
    if (error) return <p>Error :(</p>;

    return (
        <div className="ContactUs PageSingle" style={{ paddingBottom: "50px" }}>
            <section className="PageHero">
                <div className="AppContainer">
                    <h1 className="title">{page.title}</h1>
                    {/* <h2 className="title mb-0">{page.titlePrefix}</h2> */}
                </div>
            </section>
            <div className="AppContainer">
                {page.sections.map((section, index) => (
                    <Card bordered={false} className="CardItem mb-25">
                        <Row gutter={[20, 0]}>
                            <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }}>
                                <div dangerouslySetInnerHTML={{ __html: section.content }}></div>
                            </Col>
                        </Row>
                    </Card>
                ))}
            </div>
        </div>
    );
}
